const ms_MY = {
  restartInterviewButton: 'Mulakan semula',
  restartInterviewConfirmTitle: 'Mulakan temu bual baharu?',
  restartInterviewConfirmDescription: 'Temu bual baharu akan bermula dari awal. Rekod temu bual sedia ada akan disimpan.',
  restartInterviewCancel: 'Batal',
  restartInterviewFailed: 'Tidak dapat memulakan semula temu bual. Sila cuba lagi nanti.',
  restartInterviewLimitReached: 'Had temu bual telah dicapai. Anda tidak boleh memulakan temu bual baharu.',
  restartInterviewClosed: 'Temu bual ini telah ditutup. Anda tidak boleh memulakan temu bual baharu.',
  restartInterviewCutoff: 'Tarikh akhir temu bual telah berlalu. Anda tidak boleh memulakan temu bual baharu.',
  interviewLoading: 'Memuatkan temu bual…',
  interviewLinkInvalid: 'Pautan temu bual tidak sah',
  interviewLoadFailed: 'Tidak dapat memuatkan temu bual. Sila cuba lagi nanti.',
  interviewRetry: 'Cuba lagi',
  saveInfoFailed: 'Tidak dapat menyimpan maklumat anda. Sila cuba lagi.',
  loadLatestInterviewFailed: 'Tidak dapat memuatkan rekod temu bual terkini. Sila cuba lagi nanti.',
  interviewProgressSaved: 'Kemajuan temu bual anda tidak akan hilang',
  previousStimulus: 'Konsep sebelumnya',
  nextStimulus: 'Konsep seterusnya',
  expandStimulus: 'Besarkan konsep',
  closeStimulusPreview: 'Tutup pratonton konsep',
  stimulusPreview: 'Pratonton konsep',
  imageTooLarge: 'Saiz imej tidak boleh melebihi 10 MB',
  imageFormatJpegPngOnly: 'Hanya imej PNG dan JPEG disokong',
  imageFilesOnly: 'Hanya fail imej boleh dimuat naik',
  imageUploadFailed: 'Tidak dapat memuat naik imej. Sila cuba lagi.',
  finalUploadFailed: 'Tidak dapat memuat naik fail. Sila cuba lagi.',
  Welcome: 'Selamat datang ke temu bual untuk',
  StartInterview: 'Mulakan temu bual',
  Submit: 'Hantar',
  Stoprecording: 'Hentikan rakaman',
  Aiinterviewer: 'PENEMU BUAL AI',
  AiModeratedInterview: 'TEMU BUAL DIKENDALIKAN AI',
  TalkToAva: 'Bercakap dengan Ava',
  microphoneAccessTitle: 'Benarkan akses mikrofon',
  microphoneAccessDescription: 'Ava memerlukan mikrofon anda untuk perbualan suara yang lancar.',
  microphoneAllow: 'Benarkan mikrofon',
  microphoneNotNow: 'Bukan sekarang',
  microphoneConnectedTitle: 'Mikrofon disambungkan',
  microphoneConnectedDescription: 'Semuanya sudah sedia. Ava sedia mendengar.',
  microphoneDeniedTitle: 'Akses mikrofon diperlukan',
  microphoneDeniedDescription: 'Benarkan akses mikrofon dalam tetapan pelayar anda, kemudian cuba lagi.',
  microphoneTryAgain: 'Cuba lagi',
  VoiceAnswer: 'Jawapan suara',
  TextAnswer: 'Jawapan teks',
  StudyMainTitle: 'Sebelum temu bual, kami akan menjalankan saringan ringkas',
  StudyMainTip: 'Maaf, anda bukan dalam kumpulan sasaran temu bual ini dan tidak boleh menyertainya',
  TitleTop: 'ANDA DIJEMPUT!',
  HeardVoice: 'SUARAKAN PENDAPAT ANDA DAN DAPATKAN GANJARAN',
  Sophie: 'Perbualan santai selama 5–10 minit bersama Ava',
  Sponsored: 'Ditaja oleh Santa Claus🎅',
  Chikkens: 'Mulakan perbualan ringkas dan dapatkan ganjaran',
  Dollars: 'dengan CHIMOJI unik anda',
  Congrats: 'TAHNIAH!',
  ThankYou: 'Terima kasih atas pandangan anda',
  Identity: 'Pilih identiti anda',
  Refresh: 'Memuat semula halaman tidak akan menghilangkan kemajuan perbualan ini',
  Carousel: 'Sedikit kelewatan mungkin berlaku bergantung pada sambungan internet',
  CheckOut: 'Ingin mencipta temu bual seperti ini? Lihat ',
  Rewarded: 'Jika anda ingin menerima ganjaran, penemu bual memerlukan maklumat anda ',
  InterviewerReward: 'Ini ganjaran daripada penemu bual anda ',
  Register: 'Daftar atau log masuk sebagai',
  Insighteer: 'INSIGHTEER',
  Reward: 'untuk mendapatkan ganjaran anda',
  CreatePassword: 'dengan mencipta kata laluan untuk melengkapkan pendaftaran',
  Becoming: 'Menjadi',
  Password: 'Sila masukkan kata laluan anda!',
  ChooseTopic: 'Pilih topik yang menarik minat anda',
  Awesome: 'Hebat!',
  Rocks: 'HEBAT',
  Followus: 'Ikuti kami',
  Unique: 'CHIMOJI unik ini dicipta daripada perbualan anda sebagai NFT pada rantaian blok',
  Next: 'SETERUSNYA',
  ViewRewards: 'LIHAT GANJARAN',
  endMeg1: 'Tinggalkan alamat e-mel anda supaya kami dapat menghantar rakaman suara kepada anda',
  endMeg2: 'Tinggalkan maklumat anda untuk menerima insentif daripada pencipta temu bual ini',
  endMeg3: 'Tinggalkan maklumat anda untuk pencipta temu bual ini',
  endMsg5: 'Tinggalkan maklumat anda untuk mendapatkan ',
  endMsg6: 'keputusan ujian MBTI anda',
  Done: 'SELESAI',
  Done1: 'SELESAI',
  GetIncentives: 'DAPATKAN INSENTIF',
  GetStartedFreeNow: 'Mulakan secara percuma sekarang',
  UniqueChimojiNFT: 'NFT CHIMOJI unik',
  endMsg4: 'Ingin mencipta temu bual anda sendiri?',
  ResumeInterview: 'Klik untuk menyambung semula temu bual',
  interviewPausedTitle: 'Temu bual dijeda',
  interviewPausedDescription: 'Kemajuan anda telah disimpan. Anda boleh menyambung semula apabila bersedia.',
  resumeInterviewButton: 'Sambung semula temu bual',
  pauseInterview: 'Jeda',
  pauseInterviewConfirmTitle: 'Jeda temu bual?',
  pauseInterviewConfirmContent: 'Kemajuan anda akan disimpan. Anda boleh menyambung semula kemudian.',
  pauseInterviewConfirmOk: 'Jeda',
  pauseInterviewConfirmCancel: 'Teruskan temu bual',
  poorConnection: 'Sambungan lemah',
  connectionReconnectingTitle: 'Menyambung semula…',
  connectionReconnectingDescription: 'Biarkan halaman ini terbuka. Ava sedang memulihkan sambungan anda.',
  connectionReconnectedTitle: 'Sambungan dipulihkan',
  connectionReconnectedDescription: 'Anda kembali dalam talian. Temu bual diteruskan.',
  connectionDisconnectedTitle: 'Sambungan terputus',
  connectionDisconnectedDescription: 'Kemajuan temu bual anda telah disimpan.',
  refresh: 'Memuat semula halaman tidak akan menghilangkan kemajuan anda',
  voiceSnapshot: 'Sorotan suara',
  fromInterview: 'Daripada temu bual saya bersama Ava, kurator cerita AI',
  findMore: 'Ketahui lebih lanjut di Chikka.ai',
  msg1: 'UJI MBTI ANDA DALAM 5 MINIT DENGAN BERCAKAP KEPADA AVA',
  speaking: 'Anda sedang bercakap…',
  avaSpeaking: 'Ava sedang bercakap…',
  avaListening: 'Ava sedang mendengar…',
  stimuliConversationWithAva: 'Anda sedang berbual dengan Ava',
  stimuliReviewConcepts: 'Teliti konsep di bawah dan jawab soalan Ava.',
  stimuliSwipeInstruction: 'Leret ke kiri atau kanan untuk melihat semua konsep.',
  stimuliFullscreenInstruction: 'Klik dua kali pada imej untuk melihatnya dalam skrin penuh.',
  finalUploadTitleFallback: 'Muat naik fail',
  finalUploadInstructionFallback: 'Tambahkan fail sebelum menamatkan temu bual',
  finalUploadTap: 'Ketik untuk memuat naik',
  finalUploadHelp: 'Fail anda membantu kami memahami pengalaman anda dengan lebih baik.',
  finalUploadLimit: 'Maksimum 10 fail',
  finalUploadSubmit: 'HANTAR',
  finalUploadSkip: 'Langkau',
  finalUploadWait: 'Sila tunggu sehingga semua fail selesai dimuat naik',
}

export default ms_MY
